import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=1c0cd024&scoped=true&lang=pug&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&id=1c0cd024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0cd024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0cd024')) {
      api.createRecord('1c0cd024', component.options)
    } else {
      api.reload('1c0cd024', component.options)
    }
    module.hot.accept("./VideoThumbnail.vue?vue&type=template&id=1c0cd024&scoped=true&lang=pug&", function () {
      api.rerender('1c0cd024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/video/VideoThumbnail.vue"
export default component.exports